import type { PlanTier } from './interfaces';

const allTiers: PlanTier[] = ['', 'free', 'basic', 'team', 'business', 'employee'];

export const getPlanTierByString = (planName: string): PlanTier => {
  const foundTier = allTiers.find((tier) => <PlanTier>planName?.toLowerCase() === tier);
  if (!foundTier) {
    return '';
  }
  return foundTier;
};
